import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import {
  getLngAllocationsForLsoPageParamsSchema,
  getLngAllocationsForShipperPageParamsSchema,
} from 'src/pages/lng/allocations/overview/schema';
import { allocationsCommonFilters } from 'src/pages/lng/allocations/overview/utils';

export function useLngAllocationsForLsoPageParams() {
  return usePageParamsFromSchema(getLngAllocationsForLsoPageParamsSchema(), {
    filters: {
      ...allocationsCommonFilters,
      shipperOrganisationId: { label: 'Shipper' },
    },
  });
}

export type LngAllocationsForLsoPageParams = ReturnType<
  typeof useLngAllocationsForLsoPageParams
>;

export function useLngAllocationsForShipperPageParams() {
  return usePageParamsFromSchema(
    getLngAllocationsForShipperPageParamsSchema(),
    {
      filters: {
        ...allocationsCommonFilters,
        lsoOrganisationId: { label: 'LSO Name' },
      },
    }
  );
}

export type LngAllocationsForShipperPageParams = ReturnType<
  typeof useLngAllocationsForShipperPageParams
>;
